/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The recognized Country codes for SAP.
 */
export type SapCountryCodes = 'ENG' | 'IOM' | 'NIR' | 'SCT' | 'WLS';

export const SapCountryCodes = {
    Eng: 'ENG' as SapCountryCodes,
    Iom: 'IOM' as SapCountryCodes,
    Nir: 'NIR' as SapCountryCodes,
    Sct: 'SCT' as SapCountryCodes,
    Wls: 'WLS' as SapCountryCodes
};

